import React, { useState, useEffect, useRef } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { setVendorName } from '../../redux/actions/vendorAction'
import HttpService from '../../services/httpService'
import { connect } from 'react-redux'
import { useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import TableHead from '@material-ui/core/TableHead';
import { DownloadOutlined, FileFilled, RobotFilled, RollbackOutlined } from '@ant-design/icons';
import { Button, Input, Menu } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { ROLENAME } from '../../utils/index';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Box } from '@material-ui/core';



const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    // const { vendorDetail } = useSelector(state => state.vendor)

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
    table: {
        minWidth: 500,
    },
    textField: {
        width: "150px"
    },
    paperClass: {
        height: '100%'
    },
    returnButton: { backgroundColor: 'white', color: '#EF3F32', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#EF3F32", color: 'white' } },
    approveButton: { backgroundColor: 'white', color: '#157525', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#355025", color: 'white' } },
    UploadDocsbuttons: { borderRadius: 50, backgroundColor: 'white', color: '#2c2e3e', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#2c2e3e", color: 'white' } },
    deleteIcon: { cursor: "pointer", verticalAlign: 'middle', marginLeft: 10, color: "red", fontSize: 20 },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
    },
    body: {
        fontSize: 14,
        backgroundColor: "#fff",
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const SkpApprovals = (props) => {
    let j = 1;
    const classes = useStyles2();
    useEffect(() => {
        getAllSkpApprovals()
    }, [])

    const { userDetails } = useSelector(state => state.user)
    const [skpApprovalLeads, setSkpApprovalLeads] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, skpApprovalLeads.length - page * rowsPerPage)
    const [leadDetails, setLeadDetails] = useState({})
    const [openSkpDialogForApproval, setOpenSkpDialogForApproval] = useState(false)
    const [openSkpDialogForRejection, setOpenSkpDialogForRejection] = useState(false)
    const [skpRejectionRemarks, setSkpRejectionRemarks] = useState("")
    const [skpApprovalRemarks, setApprovalRemarks] = useState("")
    const [loading, setLoading] = useState(false);



    const getAllSkpApprovals = async () => {
        setLoading(true); // Start the loader
        try {
            const response = await HttpService.getAllSkpApprovals(userDetails.selectedExpCenter);
            setSkpApprovalLeads(response.data);
        } catch (error) {
            props.setSnackInfo(error);
        } finally {
            setLoading(false); // Stop the loader
        }
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    const handleSkpApproval = (event, data) => {
        setLeadDetails(data)
        let role = userDetails.roles[0].name
        {
            setOpenSkpDialogForApproval(true)
        }
    }

    const handleSkpRejectFromDesign = async () => {
        props.setLoading(true)
        try {
            let obj =
            {
                leadDetails: leadDetails,
                status: 'Rejected',
                skpRejectionRemarksByDesign: skpRejectionRemarks,
                stage: leadDetails?.currentStage

            }
            await HttpService.updateSkpAppovalsForDesign(obj)
            setOpenSkpDialogForRejection(false)
            setLeadDetails({})
            getAllSkpApprovals()
        }
        catch (error) {
            console.log('error', error.message)
        }
        props.setLoading(false)
    }



    const handleRejectSkpApproval = (event, data) => {
        setLeadDetails(data)
        let role = userDetails.roles[0].name
        {
            setOpenSkpDialogForRejection(true)
        }
    }


    const handleSkpApprovalForDesign = async () => {
        props.setLoading(true)
        try {
            let obj =
            {
                leadDetails: leadDetails,
                status: 'Approved',
                skpApprovalRemarks: skpApprovalRemarks,

            }
            await HttpService.updateSkpAppovalsForDesign(obj)
            setOpenSkpDialogForApproval(false)
            setLeadDetails({})
            getAllSkpApprovals()
        }
        catch (error) {
            console.log('error', error.message)
        }
        props.setLoading(false)
    }

    const [headers, setHeaders] = useState([]);


    return (
        <div >

            {/* heading */}
            <h1 style={{ textAlign: 'center' }}>SKP & DWG Approvals</h1>
            {loading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}>
                    <Oval
                        height={80}
                        width={80}
                        color="#4fa94d"
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            )}


            {!loading && (<TableContainer component={Paper}>

                <Table className={classes.table} size="small" aria-label="custom pagination table">

                    <TableHead>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[10, 20, 50, { label: 'All', value: skpApprovalLeads?.length }]}
                                colSpan={14}
                                count={skpApprovalLeads.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { 'aria-label': 'rows per page' },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                        <TableRow>
                            <StyledTableCell style={{ textAlign: 'center' }}>Sl.No.</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Lead No.</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Project No.</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Client Name</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>SKP File</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>DWG/ACAD File</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Designer</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>ODM</StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'center' }}>Current Stage</StyledTableCell>
                            <StyledTableCell colSpan={3} style={{ textAlign: 'center' }}>Action</StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {skpApprovalLeads.length === 0 ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >

                                <p>No approvals pending</p>
                            </div>
                        ) :
                            skpApprovalLeads.map((data, i) => (

                                <>

                                    <StyledTableRow key={j++}>
                                        <StyledTableCell>
                                            {i + 1}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {
                                                data.lead_no ?
                                                    <Link to={`/project-logs/${data._id}`} target="_blank" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.lead_no}</Link> :
                                                    'NA'
                                            }

                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {
                                                data.erpProjectNo ?
                                                    <Link to={`/project-logs/${data?._id}`} target="_blank" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.erpProjectNo}</Link> :
                                                    'NA'
                                            }

                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {
                                                data.customerId ?
                                                    data.customerId.name :
                                                    'NA'
                                            }

                                        </StyledTableCell>

                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            {
                                                data.skpPendingApproval && data.skpPendingApproval !== '' ?
                                                    (<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.skpPendingApproval)}><DownloadOutlined /></Button>) :
                                                    "NA"
                                            }
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            {
                                                data.acadPendingApproval && data.acadPendingApproval !== '' ?
                                                    (<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.acadPendingApproval)}><DownloadOutlined /></Button>) :
                                                    "NA"
                                            }
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{data.designUser ? data.designUser.name : 'NA'}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{data.designManager ? data.designManager.name : 'NA'}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{data.currentStage ? data.currentStage : 'NA'}</StyledTableCell>

                                        {
                                            <StyledTableCell style={{ textAlign: 'center' }}>
                                                <Button

                                                    className={classes.approveButton}
                                                    variant="contained"
                                                    onClick={(e) => handleSkpApproval(e, data)}
                                                >
                                                    APPROVE
                                                </Button>
                                            </StyledTableCell>
                                        }

                                        {
                                            <StyledTableCell style={{ textAlign: 'center' }}>
                                                <Button

                                                    className={classes.returnButton}
                                                    variant="contained"
                                                    onClick={(e) => handleRejectSkpApproval(e, data)}
                                                >
                                                    REJECT
                                                </Button>
                                            </StyledTableCell>
                                        }
                                    </StyledTableRow>
                                </>
                            ))}

                    </TableBody>
                </Table>
            </TableContainer>)}


            <Dialog open={openSkpDialogForApproval} onClose={() => setOpenSkpDialogForApproval(false)}>
                <DialogTitle>Approve SKP/ACAD Approval</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 550 }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="custom pagination table">
                                <TableBody>
                                    <TableRow>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{ mt: 2 }}>
                        <TextField
                            label="Remarks"
                            multiline
                            rows={4}
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setApprovalRemarks(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleSkpApprovalForDesign(skpApprovalRemarks)} disabled={skpApprovalRemarks === ""} variant="contained" color="primary">
                        Proceed
                    </Button>
                    <Button onClick={() => setOpenSkpDialogForApproval(false)} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openSkpDialogForRejection} onClose={() => setOpenSkpDialogForRejection(false)}>
                <DialogTitle>Reject SKP/ACAD Approval</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 550 }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="custom pagination table">
                                <TableBody>
                                    <TableRow>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* Add Remarks TextField */}
                    <Box sx={{ mt: 2 }}>
                        <TextField
                            label="Remarks"
                            multiline
                            rows={4}
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setSkpRejectionRemarks(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleSkpRejectFromDesign(skpRejectionRemarks)} disabled={skpRejectionRemarks === ""} variant="contained" color="primary">
                        Proceed
                    </Button>
                    <Button onClick={() => setOpenSkpDialogForRejection(false)} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    )
}



export default connect(null, { setLoading, setSnackInfo })(SkpApprovals)